
import { ICategory } from "../../model/respone/san-pham/ICategory"
import { apiClient } from "../apiClient"

export const CATEGORY_API_RESOURCE = "category"
export const categoryApi = {
    SelectAll: () => apiClient.get(`${CATEGORY_API_RESOURCE}`),
    Insert: (payload: ICategory) => apiClient.post(`${CATEGORY_API_RESOURCE}`, payload),
    Update: (payload: ICategory) => apiClient.put(`${CATEGORY_API_RESOURCE}`, payload),
    Delete: (id: number) => apiClient.delete(`${CATEGORY_API_RESOURCE}/${id}`),
}